import { Box, TextField, Button, Typography } from "@mui/material";

export default function AddNewPatient({ patient, setPatient }) {

  const handleNameChange = (value) => {
    setPatient(prev => ({
      ...prev,
      name: value
    }));
  };

  const handleDiagnosiChange = (value, index) => {
    const updated = [...patient.diagnosi];
    updated[index] = value;

    setPatient(prev => ({
      ...prev,
      diagnosi: updated
    }));
  };

  const addDiagnosiField = () => {
    setPatient(prev => ({
      ...prev,
      diagnosi: [...prev.diagnosi, ""]
    }));
  };

  const removeDiagnosiField = (index) => {
    const updated = patient.diagnosi.filter((_, i) => i !== index);

    setPatient(prev => ({
      ...prev,
      diagnosi: updated
    }));
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      
      <Typography variant="h6">Nuovo Paziente</Typography>

      <TextField
        label="Nome e Cognome"
        value={patient.name}
        onChange={(e) => handleNameChange(e.target.value)}
        fullWidth
      />

      <Typography variant="subtitle1">Diagnosi</Typography>

      {patient.diagnosi.map((d, index) => (
        <Box key={index} sx={{ display: "flex", gap: 1 }}>
          <TextField
            label={`Diagnosi ${index + 1}`}
            value={d}
            onChange={(e) => handleDiagnosiChange(e.target.value, index)}
            fullWidth
          />
          <Button color="error" onClick={() => removeDiagnosiField(index)}>
            X
          </Button>
        </Box>
      ))}

      <Button variant="outlined" onClick={addDiagnosiField}>
        Aggiungi diagnosi
      </Button>

    </Box>
  );
}